import { NgModule } from '@angular/core';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApIconComponent } from '@ap/icon';
import { ApFloatingActionButtonComponent } from '@ap/floating-action-button';

import { ConversationalChatContainerComponent } from './conversational-chat-container.component';

/**
 * @ngdoc module
 * @name ConversationalChatContainerModule
 **/
@NgModule({
    declarations: [ConversationalChatContainerComponent],
    imports: [ApContentPipe, ApIconComponent, ApFloatingActionButtonComponent],
    exports: [ConversationalChatContainerComponent],
    providers: [ApContentService]
})
export class ConversationalChatContainerModule {}
